export const notificationMockData: INotification[] = [
  {
    id: '0',
    company: 'All',
    employees_notified: '...',
    employees_viewed: '...',
    supervisors_pdf: '...',
  },
  {
    id: '1',
    company: 'Pride Now',
    employees_notified: '...',
    employees_viewed: '...',
    supervisors_pdf: '...',
  },
  {
    id: '2',
    company: 'Pride Technologies',
    employees_notified: '...',
    employees_viewed: '...',
    supervisors_pdf: '...',
  },
];

export interface INotification {
  id: string;
  company: string;
  employees_notified: string;
  employees_viewed: string;
  supervisors_pdf: string;
}
